import {
    Container,
    Stack,
    Flex,
    Box,
    Heading,
    Text,
    Button,
    Image,
    useColorModeValue,
    AspectRatio,
    UnorderedList,
    ListItem,
    Link,
    Collapse
} from '@chakra-ui/react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { onSettingsChange } from '../redux/Features/Settings';
import heroContentJSON from '../data/heroContent.json'

export default function CallToActionWithVideo({ onModalOpen }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    console.log(heroContentJSON[0]);
    

    const CreateLink = ({
        children = null,
        href = "",
        ...rest
    }) => {
        return (
            <Link
                fontWeight={900}
                textDecoration={"underline"}
                href={href}
                color={useColorModeValue(
                    'mkyfive.700',
                )}
                _hover={{
                    opacity: .5,
                    cursor: "pointer",
                    textDecoration: "none"
                }}
                {...rest}
            >
                {children}
            </Link>
        )
    }

    const Expandable = ({
        teaser,
        children,
        textColor,
        teaserFontSize,
        teaserMarginTop,
    }) => {
        const [open, setOpen] = useState(false);
        const color1 = useColorModeValue('mkytwo.500', 'mkytwo.500')
        const color2 = useColorModeValue('mkyfour.200', 'mmkyfour.200')

        return (
            <>
                <Text
                    fontSize={teaserFontSize}
                    color={textColor}
                    mt={teaserMarginTop}
                >
                    {teaser}
                    {!open && (
                        <Box
                            as="span"
                            ml="1"
                            textDecoration="underline"
                            cursor="pointer"
                            _hover={{ opacity: 0.8 }}
                            onClick={() => setOpen(true)}
                            fontSize={"lg"}
                            color={color2}
                            textShadow="1px 1px 1px rgba(2, 2, 0, 1)"
                            fontWeight={"extrabold"}
                        >
                            … see more
                        </Box>
                    )}
                </Text>

                <Collapse in={open} animateOpacity>
                    <Box mt="4">
                        {children}
                        <Text color={textColor} mt="3">
                            <Box
                                as="span"
                                textDecoration="underline"
                                cursor="pointer"
                                _hover={{ opacity: 0.8 }}
                                onClick={() => setOpen(false)}
                                fontSize={"lg"}
                                color={color2}
                                textShadow="0 1px 3px rgba(0, 0, 0, 1)"
                                fontWeight={"extrabold"}
                            >
                                see less
                            </Box>
                        </Text>
                    </Box>
                </Collapse>
            </>
        );
    };

    const ListContent = ({
        heroContent = null
    }) => {

        const header = heroContent.header;
        const content = heroContent.content;
        const footer = heroContent.footer;
        const listColor = useColorModeValue(
                    'mkyfive.50',
                    'mkyfive.50'
                )

        return (
            <>
                <Text

                    fontSize={{ base: 'lg', lg: 'xl' }}
                    color={listColor}
                    textShadow="1px 1px 1px rgba(20, 20, 20, 1)"
                    fontWeight={"extrabold"}
                    mt={'5'}
                    textAlign="left"
                    pl={5}
                >
                    {header}
                </Text>
                <UnorderedList
                    fontSize={{ base: "lg", lg: "xl" }}
                    color={listColor}
                    textShadow="1px 1px 1px rgba(20, 20, 20, 1)"
                    fontWeight="extrabold"
                    mt="5"
                    textAlign="left"
                    pl={5}
                >
                    {content.map((c, index) => (
                        <ListItem mt={3} key={index}>
                            <Text as="span" fontWeight="extrabold">
                                {c.title}
                            </Text>
                            {c.text ? ` – ${c.text}` : ""}
                        </ListItem>
                    ))}
                </UnorderedList>
                {
                    footer && typeof footer === "string" && footer.trim() != "" ?
                    <Text

                        fontSize={{ base: 'lg', lg: 'xl' }}
                        color={listColor}
                        textShadow="1px 1px 1px rgba(20, 20, 20, 1)"
                        fontWeight={"extrabold"}
                        mt={'5'}
                        textAlign="left"
                        pl={5}
                    >
                        {footer}
                    </Text>
                    :
                    null
                }
            </>
        )

    }

    return (
        <Box
            w={'100%'}
            h={'100%'}
            bgGradient="linear(to-r, mkytwo.500, mkythree.300)"
        >
            <Container maxW={{ base: '7xl', lg: 'auto' }}>
                <Stack
                    align={'center'}
                    spacing={{ base: 8, md: 20, lg: 80 }}
                    py={{ base: 10, md: 0 }}
                    direction={{ base: 'column', md: 'row' }}
                >
                    <Stack ml={{ base: 0, lg: 0 }} flex={2} spacing={{ base: 5, md: 10 }}>
                        <Heading
                            //fontWeight={600}
                            //fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}
                            pt={{ base: 0, md: 4 }}
                        >
                            {/* <Text
                                lineHeight={1.2}
                                position={'relative'}
                                zIndex={0}
                                fontSize={{ base: '3xl', lg: '42px' }}
                                color={useColorModeValue(
                                    'mkyfive.50',
                                    'mkyfour.100'
                                )}
                            >
                                Welcome to Marketocracy Masters
                                Capital Management!
                            </Text> */}
                            <Text
                            lineHeight={1.2}
                            position="relative"
                            zIndex={0}
                            fontSize={{ base: '3xl', lg: '45px' }}
                            color={useColorModeValue(
                                'mkyfive.50',
                                'mkyfour.100'
                            )}
                            >
                            <Box 
                            as="span" 
                            display="block"
                            fontSize={{ base: '3xl', lg: '4xl' }}
                             color={useColorModeValue(
                                    'mkytwo.500',
                                    'mkytwo.500'
                                )}
                                textShadow="1px 1px 1px rgba(0, 0, 0, 1)"
                                fontStyle={"italic"}
                                fontWeight={"extrabold"}
                            >
                                Welcome to
                            </Box>

                            <Box as="span" display="block">
                                Marketocracy Masters
                            </Box>

                            <Box as="span" display="block">
                                Capital Management
                            </Box>
                            </Text>
                            <Text
                                mt={4}
                                position={'relative'}
                                zIndex={0}
                                fontSize={{ base: 'xl', lg: '3xl' }}
                                color={useColorModeValue(
                                    'mkytwo.500',
                                    'mkytwo.500'
                                )}
                                textShadow="1px 1px 1px rgba(0, 0, 0, 1)"
                                fontStyle={"italic"}
                                fontWeight={"extrabold"}
                            >
                                An SEC Registered Investment Advisor
                            </Text>
                            <Box
                            w="100%"
                            textAlign="left"
                            alignSelf="flex-start"
                            >
                            {/* <Text
                                fontSize={{ base: '2xl', lg: '3xl' }}
                                color={useColorModeValue(
                                    'mkyfive.50',
                                    'mkyfour.100'
                                )}
                                mt={'10'}
                            >
                                Start Investing America! - We're on a Mission to Democratize Investing
                            </Text> */}
                            <Expandable
                                teaser="Start Investing America! - We're on a Mission to Democratize Investing"
                                teaserFontSize={{ base: "2xl", lg: "3xl" }}
                                teaserMarginTop="10"
                                textColor={useColorModeValue(
                                    'mkyfive.50',
                                    'mkyfour.100'
                                )}
                            >
                               <ListContent
                                heroContent={heroContentJSON[0]}
                               />
                            </Expandable>

                            </Box>
                            {/* <Text
                                fontSize={{ base: 'xs', lg: 'sm' }}
                                color={useColorModeValue(
                                    'mkythree.100',
                                    'mkythree.100'
                                )}
                                mt={'5'}
                            >
                                If you are an aspiring investor and ready to invest like a
                                Marketocracy Master - <CreateLink onClick={() => {
                                    dispatch(
                                        onSettingsChange({
                                            name: 'ModalType',
                                            value: 'Questions',
                                        })
                                    );
                                    return onModalOpen();
                                }} href={null}>open an account</CreateLink> and join a community
                                where performance speaks louder than pedigree. Your money will
                                mirror the money of one or more of our Masters. Our Masters
                                have portfolios set up for all needs from capital preservation to
                                income investing to long term growth. Every Master has their own
                                money invested in their portfolios, and your money & equities are
                                securely held by our custodian, Interactive Brokers - a SEC
                                registered broker and NASDAQ listed company.
                            </Text> */}
                            <Box
                            w="100%"
                            textAlign="left"
                            alignSelf="flex-start"
                            >
                                {/* <Text
                                    fontSize={{ base: '2xl', lg: '3xl' }}
                                    color={useColorModeValue(
                                        'mkyfive.50',
                                        'mkyfour.100'
                                    )}
                                    mt={'10'}
                                >
                                    Want to learn more about investing and or aspire to be a portfolio manager
                                </Text> */}

                                <Expandable
                                    teaser="Want to learn more about investing and or aspire to be a portfolio manager"
                                    teaserFontSize={{ base: "2xl", lg: "3xl" }}
                                    teaserMarginTop="10"
                                    textColor={useColorModeValue(
                                        'mkyfive.50',
                                        'mkyfour.100'
                                    )}
                                >
                                <ListContent
                                    heroContent={heroContentJSON[1]}
                                />
                                </Expandable>

                            </Box> 
                        </Heading>
                        <Stack
                            spacing={{ base: 4, sm: 4 }}
                            justifyContent={{ base: 'center' }}
                            direction={{ base: 'column', sm: 'row' }}
                        >
                            <Button
                                mt={{ base: "30px", md: 0 }}
                                rounded={'full'}
                                size={'lg'}
                                fontWeight={'normal'}
                                borderColor={'mkyfive.50'}
                                border={'2px'}
                                px={6}
                                bg="mkytwo.500"
                                color="mkyfive.50"
                                // transform= 'transform 0.3s ease'
                                cursor="pointer"
                                _hover={{
                                    bg: 'mkyfive.50',
                                    color: 'mkytwo.500',
                                    borderColor: 'mkytwo.500',
                                    border: '2px',
                                    boxShadow: 'dark-lg',
                                    // transform: 'translateY(-8px)',
                                }}
                                onClick={() => {
                                    dispatch(
                                        onSettingsChange({
                                            name: 'ModalType',
                                            value: 'Questions',
                                        })
                                    );
                                    return onModalOpen();
                                }}
                            >
                                Open Account
                            </Button>
                            <Button
                                rounded={'full'}
                                size={'lg'}
                                fontWeight={'normal'}
                                bg="mkyfive.50"
                                color="mkytwo.500"
                                colorScheme="mkytwo.500"
                                border="2px"
                                variant="outline"
                                // transform= 'transform 0.3s ease'
                                cursor="pointer"
                                _hover={{
                                    bg: 'mkytwo.500',
                                    color: 'mkyfive.50',
                                    boxShadow: 'dark-lg',
                                    //    transform: 'tran slateY(-8px)',
                                    // transform: 'translateY(-8px)',
                                }}
                                px={6}
                                onClick={() => navigate('/investments')}
                            >
                                Learn More
                            </Button>
                        </Stack>
                    </Stack>

                    <Flex
                        flex={1}
                        //width={"full"}
                        justify={'center'}
                        align={'center'}
                        position={'relative'}
                        w={'full'}
                        display={{ base: 'none', md: 'flex' }}
                        paddingTop={"5"}
                    >
                        <AspectRatio width={'full'} maxW="400px" ratio={1 / 2}>
                            <Image
                                alt="Hero Image"
                                fit="cover"
                                objectPosition="top"   // or "center"
                                w="100%"
                                h="100%"

                                src="https://marketocracy-front-end.s3.us-east-2.amazonaws.com/logos/image1.png"
                            />
                        </AspectRatio>
                    </Flex>
                </Stack>
                <Text
                    as="i"
                    noOfLines={8}
                    textAlign={'left'}
                    fontSize={{ base: 'sm', lg: 'xs' }}
                    color={useColorModeValue('mkythree.100', 'mkythree.100')}
                    p={'5'}
                >
                    * Best-in-Class Managers refers to managers selected for
                    their long-term performance that was superior to the
                    majority of the managers competing under the same rules in
                    the original Marketocracy Portfolio Competition between the
                    years of 1999-2018.
                </Text>
            </Container>
        </Box>
    );
}
